import axios, { AxiosResponse } from "axios";
import { GetResponse, PostResponse } from "./response";
import i18n from "../../i18n";
import apiClient from "./apiClient";

interface LooseObject {
  [key: string]: any;
}

export const getClearanceDocTypeList = async (): Promise<any> => {
  try {
    const response: AxiosResponse<GetResponse> = await apiClient.get(
      `${process.env.REACT_APP_URL_DOCUMENTS_SERVICE}/reference/custom/clearance-doc-type/list`,
      {
        headers: {
          "Accept-Language": i18n.language?.includes("ru") ? "ru-RU" : "kk-KZ",
        },
        withCredentials: true,
      },
    );
    return response.data;
  } catch (error) {
    console.error("Error during authentication:", error);
    throw error;
  }
};

export const getDocMarksList = async (
  docId: string,
  page: number,
  size: number,
  sortDirection: "ASC" | "DESC" = "DESC",
): Promise<any> => {
  try {
    const params = new URLSearchParams({
      page: page.toString(),
      size: size.toString(),
      sortDirection,
    }).toString();

    const response: AxiosResponse<GetResponse> = await apiClient.get(
      `${process.env.REACT_APP_URL_DOCUMENTS_SERVICE}/documents/product/list/${docId}?${params}`,
      {
        headers: {
          "Accept-Language": i18n.language?.includes("ru") ? "ru-RU" : "kk-KZ",
        },
        withCredentials: true,
      },
    );
    return response.data;
  } catch (error) {
    console.error("Error during authentication:", error);
    throw error;
  }
};

/** Подчинённые КМ любого уровня: GET /documents/product/list/{docId}/{markId}/children */
export const getDocMarkChildren = async (
  docId: string | number,
  markId: string | number,
): Promise<any> => {
  try {
    const response = await apiClient.get(
      `${process.env.REACT_APP_URL_DOCUMENTS_SERVICE}/documents/product/list/${docId}/${markId}/children`,
      {
        headers: {
          "Accept-Language": i18n.language?.includes("ru") ? "ru-RU" : "kk-KZ",
        },
        withCredentials: true,
      },
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching document mark children:", error);
    throw error;
  }
};

export const addMarks = async (
  docId: string,
  marks: number[],
): Promise<any> => {
  try {
    const response: AxiosResponse<PostResponse> = await apiClient.post(
      `${process.env.REACT_APP_URL_DOCUMENTS_SERVICE}/documents/add-marks/${docId}`,
      marks,
      {
        headers: {
          "Content-Type": "application/json",
          "Accept-Language": i18n.language?.includes("ru") ? "ru-RU" : "kk-KZ",
        },
        withCredentials: true,
      },
    );
    return response.data;
  } catch (error) {
    console.error("Error during authentication:", error);
    throw error;
  }
};

export const addMarksByOrder = async (
  docId: string,
  ordersIds: number[],
): Promise<any> => {
  const requestBody = {
    documentId: docId,
    orderIds: ordersIds,
  };
  try {
    const response: AxiosResponse<PostResponse> = await apiClient.post(
      `${process.env.REACT_APP_URL_DOCUMENTS_SERVICE}/documents/add-marks-by-order-v2`,
      requestBody,
      {
        headers: {
          // "Content-Type": "application/json",
          "Accept-Language": i18n.language?.includes("ru") ? "ru-RU" : "kk-KZ",
        },
        withCredentials: true,
      },
    );
    return response.data;
  } catch (error) {
    console.error("Error during authentication:", error);
    throw error;
  }
};

export const addMarksResult=async(
  docId: string,
):Promise<any>=>{
  try {
    const response: AxiosResponse<GetResponse> = await apiClient.get(
      `${process.env.REACT_APP_URL_DOCUMENTS_SERVICE}/documents/search-add-marks-result/${docId}`,
      {
        headers: {
          "Accept-Language": i18n.language?.includes("ru") ? "ru-RU" : "kk-KZ",
        },
        withCredentials: true,
      },
    );
    return response.data;
  } catch (error) {
    console.error("Error during authentication:", error);
    throw error;
  }
}

export const getDocument = async (doc_id: string): Promise<any> => {
  try {
    const response: AxiosResponse<GetResponse> = await apiClient.get(
      `${process.env.REACT_APP_URL_DOCUMENTS_SERVICE}/documents/get/${doc_id}`,
      {
        headers: {
          "Accept-Language": i18n.language?.includes("ru") ? "ru-RU" : "kk-KZ",
        },
        withCredentials: true,
      },
    );
    return response.data;
  } catch (error) {
    console.error("Error during authentication:", error);
    throw error;
  }
};

export const create = async (
  files: FormData,
  onUploadProgress: any,
): Promise<any> => {
  try {
    const response: AxiosResponse<PostResponse> = await apiClient.post(
      `${process.env.REACT_APP_URL_DOCUMENTS_SERVICE}/file/upload-files`,
      files,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          "Accept-Language": i18n.language?.includes("ru") ? "ru-RU" : "kk-KZ",
        },
        withCredentials: true,
        onUploadProgress,
      },
    );
    return response.data;
  } catch (error) {
    console.error("Error during create invoice:", error);
    throw error;
  }
};

export const edit = async (filename: string): Promise<any> => {
  try {
    const response: AxiosResponse<GetResponse> = await apiClient.get(
      `${process.env.REACT_APP_URL_DOCUMENTS_SERVICE}/file/download/${filename}`,
      {
        responseType: "blob",
        headers: {
          "Accept-Language": i18n.language?.includes("ru") ? "ru-RU" : "kk-KZ",
        },
        withCredentials: true,
      },
    );
    return response.data;
  } catch (error) {
    console.error("Error during authentication:", error);
    throw error;
  }
};

export const deleteDocument = async (docId: string): Promise<any> => {
  try {
    // const requestBody = {
    //   appId: appId,
    //   docId: docId,
    // };

    const response: AxiosResponse<any> = await apiClient.delete(
      `${process.env.REACT_APP_URL_DOCUMENTS_SERVICE}/documents/delete/${docId}`,
      {
        // data: requestBody,
        headers: {
          "Content-Type": "application/json",
          "Accept-Language": i18n.language?.includes("ru") ? "ru-RU" : "kk-KZ",
        },
        withCredentials: true,
      },
    );

    return response.data;
  } catch (error) {
    console.error("Error during jewelry cards deletion:", error);
    throw error;
  }
};

interface Document {
  refDocType: number;
  refCountryExport: number;
  refCustomsClearanceDocType: number;
  customsClearanceRegNumber: string;
  customsClearanceRegAt: string; // Дата в виде строки
  refCustomsDecisionCode: number;
  customsDecisionAt: string;
  customsDecisionDocNumber: string;
  protocolNumber: string;
  protocolAt: string;
  expertNumber: string;
  expertAt: string;
  controlActNumber: string;
  controlActAt: string;
  note: string;
  documentPaperNumber: string;
  documentPaperAt: string;
  marks: number[] | null;
  id: number;
  orgId: number;
  createUser: number;
  createdAt: string;
  receiver: string;
  sender: string;
  status: any;
  docNumber: string;
}

// Определение интерфейса для ответа API с документами
interface DocumentsResponse {
  itemsPerPage: number;
  currentPage: number;
  totalItems: number;
  totalPages: number;
  documents: Document[];
}

const getDocumentsList = async (
  page: number = 1,
  size: number = 10,
  sortDirection: "ASC" | "DESC" = "DESC",
  objectData?: any,
): Promise<DocumentsResponse> => {
  try {
    const params = new URLSearchParams({
      page: page.toString(),
      size: size.toString(),
      sortDirection,
    }).toString();

    const requestBody = objectData ?? {};

    const activeGroupId = Number(
      (document.cookie.split("; ").find((row) => row.startsWith("activeGroup="))?.split("=")[1]) ?? ""
    );

    if (activeGroupId) {
      requestBody.productGroupId = +activeGroupId;
    }

    const response = await apiClient.post(
      `${process.env.REACT_APP_URL_DOCUMENTS_SERVICE}/documents/list?${params}`,
      requestBody,
      {
        headers: {
          "Content-Type": "application/json",
          "Accept-Language": i18n.language?.includes("ru") ? "ru-RU" : "kk-KZ",
        },
        withCredentials: true,
      },
    );

    return response.data as DocumentsResponse;
  } catch (error) {
    console.error("Error posting documents list:", error);
    throw error;
  }
};

export const editDocument = async (orderData: any): Promise<any> => {
  try {
    const response: AxiosResponse<any> = await apiClient.put(
      `${process.env.REACT_APP_URL_DOCUMENTS_SERVICE}/documents/edit`,
      orderData,
      {
        headers: {
          // "Content-Type": "application/json",
          "Accept-Language": i18n.language?.includes("ru") ? "ru-RU" : "kk-KZ",
        },
        withCredentials: true,
      },
    );
    return response.data;
  } catch (error) {
    console.error("Error during order editing:", error);
    throw error;
  }
};




export const deleteMarks = async (docId: any, marks: string[]) => {
  try {
    const response = await apiClient.delete(
      `${process.env.REACT_APP_URL_DOCUMENTS_SERVICE}/documents/delete-marks/${docId}`,
      {
        data: marks,
        withCredentials: true,
      },
    );
    return response.data;
  } catch (error) {
    console.error("Ошибка при удалении заказа:", error);
    throw error;
  }
};

export const downloadProblemMarksFile = async (doc_id: string) => {
  try {
    const response = await apiClient.get(
      `${process.env.REACT_APP_URL_DOCUMENTS_SERVICE}/documents/download/${doc_id}`,
      {
        withCredentials: true,
        responseType: "blob", // Важно для скачивания файла
      },
    );
    return response.data;
  } catch (error) {
    console.error("Ошибка при скачивании файла:", error);
    throw error;
  }
};

const addMarksByFile = async (docId: string, file: File): Promise<any> => {
  try {
    const activeGroupId = Number(
      (document.cookie.split("; ").find((row) => row.startsWith("activeGroup="))?.split("=")[1]) ?? ""
    );

    const url = `${process.env.REACT_APP_URL_DOCUMENTS_SERVICE}/documents/add-marks-by-file/${docId}${
      activeGroupId ? `?productGroupId=${activeGroupId}` : ""
    }`;

    const response = await apiClient.post(
      url,
      { file: file },
      {
        headers: {
          "Content-Type": "multipart/form-data",
          "Accept-Language": i18n.language?.includes("ru") ? "ru-RU" : "kk-KZ",
        },
        withCredentials: true,
      },
    );

    return response.data as DocumentsResponse;
  } catch (error) {
    console.error("Error posting documents list:", error);
    throw error;
  }
};

const addMarksByCodes = async (
  docId: string,
  markIdsOrMarkCodes: boolean,
  size: boolean,
  markIds?: number[],
  markCodes?: string[],
): Promise<any> => {
  const objectData = {
    markIdsOrMarkCodes: markIdsOrMarkCodes,
    size: size,
    markIds: markIds || null,
    markCodes: markCodes || null,
    productGroupId: null as number | null,
  };

  try {
    const activeGroupId = Number(
      (document.cookie.split("; ").find((row) => row.startsWith("activeGroup="))?.split("=")[1]) ?? ""
    );

    if (activeGroupId) {
      objectData.productGroupId = activeGroupId;
    }
    
    const response = await apiClient.post(
      `${process.env.REACT_APP_URL_DOCUMENTS_SERVICE}/documents/add-marks-by-codes-v2/${docId}`,
      objectData,
      {
        headers: {
          "Content-Type": "application/json",
          "Accept-Language": i18n.language?.includes("ru") ? "ru-RU" : "kk-KZ",
        },
        withCredentials: true,
      },
    );

    return response.data as DocumentsResponse;
  } catch (error) {
    console.error("Error posting documents list:", error);
    throw error;
  }
};

const searchMarksByDocument = async (
  docId: string,
  page: number,
  size: number,
  sortDirection: string,
  productTypeCode?: any,
  status?: any,
  statusDateStart?: string,
  statusDateEnd?: string,
  productGroupId?: number,
): Promise<any> => {
  const objectData: LooseObject = {}

  // Prefer value provided from UI (initialValues), fallback to cookie
  let productGroupIdToUse: number | null = null;
  if (Number.isFinite(productGroupId as number)) {
    productGroupIdToUse = productGroupId as number;
  } else {
    const fromCookie = Number(
      (document.cookie.split("; ").find((row) => row.startsWith("activeGroup="))?.split("=")[1]) ?? ""
    );
    productGroupIdToUse = Number.isFinite(fromCookie) ? fromCookie : null;
  }

  if (productTypeCode) {
    objectData.productTypeCode = productTypeCode;
  }
  if (status && status?.length !== 0) {
    objectData.status = status;
  }

  if (statusDateStart) {
    objectData.statusDateStart = statusDateStart;
  }

  if (statusDateEnd) {
    objectData.statusDateEnd = statusDateEnd;
  }
  if (productGroupIdToUse) {
    objectData.productGroupId = productGroupIdToUse;
  }


  const params = new URLSearchParams({
    page: page.toString(),
    size: size.toString(),
    sortDirection,
  }).toString();

  try {
    const response = await apiClient.post(
      `${process.env.REACT_APP_URL_DOCUMENTS_SERVICE}/documents/marks/list/${docId}?${params.toString()}`,
      objectData,
      {
        headers: {
          "Content-Type": "application/json",
          "Accept-Language": i18n.language?.includes("ru") ? "ru-RU" : "kk-KZ",

        },
        withCredentials: true,
      },
    );

    return response.data ;
  } catch (error) {
    console.error("Error posting documents list:", error);
    throw error;
  }
};

const getReceiverOrg = async (iinBin: string): Promise<any> => {
  try {
    const response = await apiClient.get(
      `${process.env.REACT_APP_URL_AUTH_SERVICE}/organisation/search-by-iin-bin/${iinBin}`,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          "Accept-Language": i18n.language?.includes("ru") ? "ru-RU" : "kk-KZ",

        },
        withCredentials: true,
      },
    );

    return response.data as DocumentsResponse;
  } catch (error) {
    console.error("Error posting documents list:", error);
    throw error;
  }
};

export const viewAndPrintDocument = async (doc_id: any): Promise<Blob> => {
  try {
    const response: AxiosResponse<any> = await apiClient.get(
      `${process.env.REACT_APP_URL_DOCUMENTS_SERVICE}/documents/report/${doc_id}`,
      {
        headers: {
          "Accept-Language": i18n.language?.includes("ru") ? "ru-RU" : "kk-KZ",
          responseType: "blob",
        },
        withCredentials: true,
        responseType: "blob",
      },
    );
    return response.data;
  } catch (error) {
    console.error("Ошибка при просмотре и печати документа:", error);
    throw error;
  }
};

/** Итоги документа: GET /documents/report/{docId}/totals */
export const getDocumentTotals = async (
  docId: string | number,
): Promise<{ ntinName?: string; ntin?: string; kmType?: string; count?: number }[]> => {
  try {
    const response = await apiClient.get(
      `${process.env.REACT_APP_URL_DOCUMENTS_SERVICE}/documents/report/${docId}/totals`,
      {
        headers: {
          "Accept-Language": i18n.language?.includes("ru") ? "ru-RU" : "kk-KZ",
        },
        withCredentials: true,
      },
    );
    const data = response.data;
    if (Array.isArray(data)) return data;
    return data?.totals || data?.data || [];
  } catch (error) {
    console.error("Error fetching document totals:", error);
    throw error;
  }
};

export const downloadDocumentMarks = async (doc_id: any): Promise<any> => {
  try {
    const response: AxiosResponse<any> = await apiClient.get(
      `${process.env.REACT_APP_URL_DOCUMENTS_SERVICE}/documents/download/${doc_id}`,
      {
        // headers: {
        //   // "Accept-Language": "ru-RU",
        //   // responseType: "blob",
        //   // "Accept-Language": i18n.language,
        //   "Content-Type": "application/octet-stream",
        //   "Content-Disposition": "attachment",
        // },
        withCredentials: true,
        responseType: "blob",
        // responseType: "document"
      },
    );

    return response?.data;
  } catch (error) {
    console.error("Ошибка при просмотре и печати документа:", error);
    throw error;
  }
};


export const deleteMarksPersonalization = async (docId: any,productId:any,marks: number[]) => {
  try {
    const response = await apiClient.delete(
      `${process.env.REACT_APP_URL_DOCUMENTS_SERVICE}/documents/personalization/product/marks/${docId}/${productId}`,
      {
        data: marks,
        withCredentials: true,
      },
    );
    return response.data;
  } catch (error) {
    console.error("Ошибка при удалении заказа:", error);
    throw error;
  }
};

export const editDocumentPersonalization = async (docId:any,productId:any,orderData: any): Promise<any> => {
  const marks = {'marks':orderData}
  try {
    const response: AxiosResponse<any> = await apiClient.put(
      `${process.env.REACT_APP_URL_DOCUMENTS_SERVICE}/documents/personalization/manual/product/mark/edit/${docId}/${productId}`,
      marks,
      {
        headers: {
          // "Content-Type": "application/json",
          "Accept-Language": i18n.language?.includes("ru") ? "ru-RU" : "kk-KZ",
        },
        withCredentials: true,
      },
    );
    return response.data;
  } catch (error) {
    console.error("Error during order editing:", error);
    throw error;
  }
};

const langHeaders = () => ({
  "Content-Type": "application/json",
  "Accept-Language": i18n.language?.includes("ru") ? "ru-RU" : "kk-KZ",
});

/** Поиск групп-кандидатов для разагрегации */
export const getDeaggregationMarksList = async (
  page: number,
  size: number,
  body: { productTypeCode?: string; productGroupId?: number },
  sortDirection: "ASC" | "DESC" = "DESC",
): Promise<any> => {
  const params = new URLSearchParams({
    page: String(page),
    size: String(size),
    sortDirection,
  }).toString();
  try {
    const response = await apiClient.post(
      `${process.env.REACT_APP_URL_DOCUMENTS_SERVICE}/documents/marks/deaggregation/list?${params}`,
      body,
      { headers: langHeaders(), withCredentials: true },
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching deaggregation marks list:", error);
    throw error;
  }
};

/** Добавить составы групп в документ разагрегации */
export const addDeaggregationMarks = async (
  docId: string | number,
  items: { markId: number; sourceAggregationDocumentId: number }[],
): Promise<any> => {
  try {
    const response = await apiClient.post(
      `${process.env.REACT_APP_URL_DOCUMENTS_SERVICE}/documents/marks/deaggregation/add/${docId}`,
      { items },
      { headers: langHeaders(), withCredentials: true },
    );
    return response.data;
  } catch (error) {
    console.error("Error adding deaggregation marks:", error);
    throw error;
  }
};

/** Поиск заказов с марками для агрегации */
export const getAggregationOrdersList = async (
  docId: string | number,
  page: number,
  size: number,
  body: {
    parentMarkId?: number;
    productTypeCode?: string;
    productGroupId?: number;
  },
  sortDirection: "ASC" | "DESC" = "DESC",
): Promise<any> => {
  const params = new URLSearchParams({
    page: String(page),
    size: String(size),
    sortDirection,
  }).toString();
  try {
    const response = await apiClient.post(
      `${process.env.REACT_APP_URL_DOCUMENTS_SERVICE}/documents/marks/aggregation/orders/list/${docId}?${params}`,
      body,
      { headers: langHeaders(), withCredentials: true },
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching aggregation orders list:", error);
    throw error;
  }
};

/** Поиск марок для добавления к агрегационному документу */
export const getAggregationMarksList = async (
  docId: string | number,
  page: number,
  size: number,
  body: {
    parentMarkId?: number;
    productTypeCode?: string;
    productGroupId?: number;
  },
  sortDirection: "ASC" | "DESC" = "DESC",
): Promise<any> => {
  const params = new URLSearchParams({
    page: String(page),
    size: String(size),
    sortDirection,
  }).toString();
  try {
    const response = await apiClient.post(
      `${process.env.REACT_APP_URL_DOCUMENTS_SERVICE}/documents/marks/aggregation/list/${docId}?${params}`,
      body,
      { headers: langHeaders(), withCredentials: true },
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching aggregation marks list:", error);
    throw error;
  }
};

/** Добавить связи марок к агрегационному документу (в т.ч. по кодам / скану) */
export const addAggregationMarks = async (
  docId: string | number,
  body: {
    parentMarkId: number;
    markIds?: number[];
    markCodes?: string[];
    markIdsOrMarkCodes?: boolean;
  },
): Promise<any> => {
  try {
    const response = await apiClient.post(
      `${process.env.REACT_APP_URL_DOCUMENTS_SERVICE}/documents/marks/aggregation/add/${docId}`,
      body,
      { headers: langHeaders(), withCredentials: true },
    );
    return response.data;
  } catch (error) {
    console.error("Error adding aggregation marks:", error);
    throw error;
  }
};

/** Добавить связи марок из заказов к агрегационному документу */
export const addAggregationMarksByOrders = async (
  docId: string | number,
  body: { parentMarkId: number; orderIds: number[] },
): Promise<any> => {
  try {
    const response = await apiClient.post(
      `${process.env.REACT_APP_URL_DOCUMENTS_SERVICE}/documents/marks/aggregation/add-by-orders/${docId}`,
      body,
      { headers: langHeaders(), withCredentials: true },
    );
    return response.data;
  } catch (error) {
    console.error("Error adding aggregation marks by orders:", error);
    throw error;
  }
};

/** Добавить связи марок из файла к агрегационному документу */
export const addAggregationMarksByFile = async (
  docId: string | number,
  parentMarkId: number,
  file: File,
): Promise<any> => {
  try {
    const response = await apiClient.post(
      `${process.env.REACT_APP_URL_DOCUMENTS_SERVICE}/documents/marks/aggregation/add-by-file/${docId}?parentMarkId=${parentMarkId}`,
      { file },
      {
        headers: {
          "Content-Type": "multipart/form-data",
          "Accept-Language": i18n.language?.includes("ru") ? "ru-RU" : "kk-KZ",
        },
        withCredentials: true,
      },
    );
    return response.data;
  } catch (error) {
    console.error("Error adding aggregation marks by file:", error);
    throw error;
  }
};

/** Подчинённые марки агрегационного документа */
export const getAggregationChildren = async (
  docId: string | number,
  page: number = 1,
  size: number = 10,
  sortDirection: "ASC" | "DESC" = "DESC",
): Promise<any> => {
  const params = new URLSearchParams({
    page: String(page),
    size: String(size),
    sortDirection,
  }).toString();
  try {
    const response = await apiClient.get(
      `${process.env.REACT_APP_URL_DOCUMENTS_SERVICE}/documents/marks/aggregation/children/${docId}?${params}`,
      { headers: langHeaders(), withCredentials: true },
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching aggregation children:", error);
    throw error;
  }
};

/** Удалить подчинённые марки из агрегационного документа */
export const deleteAggregationChildren = async (
  docId: string | number,
  body: {
    markIds?: number[];
    markCodes?: string[];
    markIdsOrMarkCodes?: boolean;
  },
): Promise<any> => {
  try {
    const response = await apiClient.delete(
      `${process.env.REACT_APP_URL_DOCUMENTS_SERVICE}/documents/marks/aggregation/children/${docId}`,
      {
        data: body,
        headers: langHeaders(),
        withCredentials: true,
      },
    );
    return response.data;
  } catch (error) {
    console.error("Error deleting aggregation children:", error);
    throw error;
  }
};

const DocumentsService = {
  addMarks,
  getDocumentsList,
  getDocument,
  create,
  edit,
  deleteDocument,
  editDocument,
  getClearanceDocTypeList,
  getDocMarksList,
  getDocMarkChildren,
  deleteMarks,
  addMarksByOrder,
  addMarksResult,
  downloadProblemMarksFile,
  addMarksByFile,
  addMarksByCodes,
  searchMarksByDocument,
  getReceiverOrg,
  viewAndPrintDocument,
  getDocumentTotals,
  downloadDocumentMarks,
  deleteMarksPersonalization,
  editDocumentPersonalization,
  getDeaggregationMarksList,
  addDeaggregationMarks,
  getAggregationOrdersList,
  getAggregationMarksList,
  addAggregationMarks,
  addAggregationMarksByOrders,
  addAggregationMarksByFile,
  getAggregationChildren,
  deleteAggregationChildren,
};

export default DocumentsService;
